import introduceOperator from "@/assets/audio/introduce-operator";

export default {
    methods: {
        playOperatorSound() {
            const p = introduceOperator.play();
            p.then(() => {}).catch(() => {});
        }
    }
}